import React from 'react';

import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

import { ReactComponent as Icon } from 'components/mui/Icons/IconBundleDownload/icon.svg';

type IconBundleDownloadProps = Omit<SvgIconProps, 'component'>;

function IconBundleDownload(props: IconBundleDownloadProps): JSX.Element {
  return <SvgIcon component={Icon} inheritViewBox {...props} />;
}

export default IconBundleDownload;
